if (!document.documentElement.hasAttribute('data-league-belt-guide-bound')) {
  document.documentElement.setAttribute('data-league-belt-guide-bound', '');
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.league-belt-guide-link button');
    if (!trigger) return;
    const opener = trigger.closest('open-or-scroll-to');
    const guide = opener && document.getElementById(opener.dataset.targetId);
    if (guide && !guide.open) guide.querySelector('summary').click();
  }, true);
}
